export enum ExpensesClassificationCategoryType {
category2_1,
category2_2,
category2_3,
category2_4,
category2_5,
category2_6,
category2_7,
category2_8,
category2_9,
category2_10,
category2_11,
category2_12,
category2_13,
category2_14,
category2_95,
}
